import api from "../api";

const api_type = 'v1'

export const GetCashSummary = params => { return api.post(api_type+`/cash/summary`, params) }
export const GetCashChannelSummary = params => { return api.post(api_type+`/cash/channel_summary`, params) }
export const GetCashCheck = params => { return api.post(api_type+`/cash/check`, params) }
export const GetCashCheckChannel = params => { return api.post(api_type+`/cash/check_channel`, params) }
export const GetCashChannelDate = params => { return api.post(api_type+`/cash/channel_date`, params) }
export const GetCashChannel = params => { return api.post(api_type+`/cash/channel`, params) }
export const GetCashCountry = params => { return api.post(api_type+`/cash/country`, params) }
export const GetCashAnalysis = params => { return api.post(api_type+`/cash/analysis`, params) }
export const GetCashRatio = params => { return api.post(api_type+`/cash/get_ratio`, params) }
export const ChangeCashRatio = params => { return api.post(api_type+`/cash/change_ratio`, params) }



// WEBPACK FOOTER //
// ./src/api/v1/cash_api.js